import { HospitalApi } from '@/api/hospital';
import HospitalStore from '@/store/hospital';
import { StoreService } from '@/services/store-service';

export class HospitalService {

    constructor(client, store, router) {                
        this.api = new HospitalApi(client);
        this.store = StoreService.new(store, HospitalStore);    
        this.router = router;
    }
    
    async list() {
        const cachedItems = this.store.get('sites');
        
        if (cachedItems) return cachedItems;        

        const response = await this.api.list();
        await this.store.dispatch('sites', response.sites); 
          
                      
        return response.sites;
    }  

    async getContact(id){
        const cachedItems = this.store.get('contact');
        if (cachedItems) return cachedItems;        

        const response = await this.api.getContact(id);

        await this.store.dispatch('contact', response);        
        
        return response;
    }

  

    async changeContactDetails(id, data){
        data.id = id;
        const response = await this.api.changeContactDetails(data);
        await this.store.dispatch('changeContactDetails', data);
        return response;
    }

    async changeHospitalName(data){
        const response = await this.api.changeHospitalName(data);
        await this.store.dispatch('changeHospitalName', data);   
        return response;
    }
}